import styled from "styled-components";

export const GalerySec = styled.section`
  max-width: 1200px;
  margin-top: 160px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 24px;

  @media screen and (max-width: 768px) {
    margin-top: 60px;
  }
`;

export const GaleryItem = styled.div`
  margin: 12px;
`;